require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-boost-career-non-programming-jobs-benefit-coding-education.json") })
        }
      }, "path---blog-boost-career-non-programming-jobs-benefit-coding-education");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-boost-career-non-programming-jobs-benefit-coding-education!./.cache/json/blog-boost-career-non-programming-jobs-benefit-coding-education.json
// module id = 728
// module chunks = 231608221292675